import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	content: {
		boxSizing: 'border-box',
		height: 'calc(100vh - 270px)',
		minHeight: 400,
		paddingBottom: SPACE[24],
	},
	selectContent: {
		background: THEME.colors.background.light,
	},
	selectRow: {
		width: 180,
	},
	selectTrigger: {
		background: THEME.colors.background.light,
		width: '100%',
	},
});
